module.exports = __webpack_public_path__ + "assets/webstock-0760ca51ddcaf472ee24e2e27521d220.svg";